import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Dish } from 'types';

export const deleteDish = (dishId: number) => {
  return axios.delete(`/api/dishes/${dishId}`);
};

type UseDeleteDishOptions = {
  config?: MutationConfig<typeof deleteDish>;
};

export const useDeleteDish = ({ config }: UseDeleteDishOptions) => {
  return useMutation({
    onMutate: async (deletedDishId: number) => {
      await queryClient.cancelQueries(['dishes']);

      const previousDishes = queryClient.getQueryData<Dish[]>(['dishes']);

      queryClient.setQueryData(
        ['dishes'],
        previousDishes?.filter((dish) => dish.id !== deletedDishId)
      );

      return previousDishes;
    },
    onError: (_, __, context: any) => {
      if (context?.previousAnalyzers) {
        queryClient.setQueryData(['dishes'], context.previousDishs);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['dishes']);
      queryClient.invalidateQueries(['analyzerDish']);
      queryClient.invalidateQueries(['weatherAlerts']);
      queryClient.invalidateQueries(['locations']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: deleteDish,
  });
};
